import { ValidationSchema } from 'forms';
import {
  PERSONAL_PAN_REGEX,
  AADHAAR_REGEX,
  PHONE_NUMBER_REGEX,
  EMAIL_REGEX,
  PAN_REGEX,
} from 'utils/regexes';
import {
  KycFormFields,
  PersonalDetailsFormFields,
} from 'components/EmployeeOnboarding/ContractorSelfOnboarding/types';

const EMAIL_PATTERN = new RegExp(EMAIL_REGEX);
const PHONE_NUMBER_PATTERN = new RegExp(PHONE_NUMBER_REGEX);
const PAN_PATTERN = new RegExp(PAN_REGEX);

export const validateAadhar = (aadhar: string): boolean => {
  const cleanAadhar = aadhar.replace(/\s/g, '');
  return AADHAAR_REGEX.test(cleanAadhar);
};

export const validatePhoneNumber = (phoneNumber: string): boolean => {
  return PHONE_NUMBER_PATTERN.test(phoneNumber.replace(/\s/g, ''));
};

export const validateEmail = (email: string): boolean => {
  return EMAIL_PATTERN.test(email);
};

export const validateDateOfBirth = (date: Date | null): boolean => {
  if (!date) return false;
  const today = new Date();
  return date <= today;
};

export const getKycValidationSchema = ({
  isContractorPanValidationEnabled,
}: {
  isContractorPanValidationEnabled: boolean;
}): ValidationSchema<KycFormFields> => ({
  pan: (formData) => {
    if (!formData.pan) {
      return null;
    }
    if (isContractorPanValidationEnabled && !PERSONAL_PAN_REGEX.test(formData.pan)) {
      return 'Enter a valid personal PAN';
    }

    if (!isContractorPanValidationEnabled && !PAN_PATTERN.test(formData.pan)) {
      return 'Enter a valid PAN';
    }
    return null;
  },
  aadharNumber: (formData) => {
    if (isContractorPanValidationEnabled && !formData.aadharNumber) {
      return 'Aadhaar number is required';
    }
    if (formData.aadharNumber && !AADHAAR_REGEX.test(formData.aadharNumber)) {
      return 'Enter a valid 12-digit Aadhaar number';
    }
    return null;
  },
  verificationConsent: (formData) => {
   if (!formData.pan) return null;
   return !formData.verificationConsent ? 'Please provide consent for validation' : null;
  }
});

export const getPersonalDetailsValidationSchema =
  (): ValidationSchema<PersonalDetailsFormFields> => ({
    gender: (formData) => (!formData.gender?.[0] ? 'Gender is required' : null),
    dob: (formData) => {
      if (!formData.dob) {
        return 'Date of birth is required';
      }
      if (!validateDateOfBirth(formData.dob)) {
        return 'Please enter a valid date of birth';
      }
      return null;
    },
    personalEmail: (formData) => {
      if (formData.personalEmail?.trim() && !validateEmail(formData.personalEmail)) {
        return 'Please enter a valid email address';
      }
      return null;
    },
    phoneNumber: (formData) => {
      if (formData.phoneNumber?.trim() && !validatePhoneNumber(formData.phoneNumber)) {
        return 'Please enter a valid phone number';
      }
      return null;
    },
  });

export const getReviewDetailsValidationSchema = ({
  isContractorPanValidationEnabled,
}: {
  isContractorPanValidationEnabled: boolean;
}) => ({
  ...getKycValidationSchema({ isContractorPanValidationEnabled }),
  ...getPersonalDetailsValidationSchema(),
});
